// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import { version } from './version';

export const environment = {
  production: false,
  appVersionAddon: '-staging',
  webappName: 'ZGW Portaal Behandelaar (staging)',
  api_endpoint: 'https://api.zgw-staging.nl/',
  pusher: {
    broadcaster: 'pusher',
    key: '2f96a9d777bbe9318f82',
    cluster: 'eu',
    forceTLS: true,
  },
  pusher_beams_client_id: null,
  sentry: {
    dsn: 'https://1053763a6ff3cfe277176805986cd903@o4507735602298880.ingest.de.sentry.io/4511093779005520',
    environment: 'staging',
    version: version + '-staging',
  },
};
